import { render, staticRenderFns } from "./AllocationAssets.vue?vue&type=template&id=fad9126e"
import script from "./AllocationAssets.vue?vue&type=script&lang=js"
export * from "./AllocationAssets.vue?vue&type=script&lang=js"
import style0 from "./AllocationAssets.vue?vue&type=style&index=0&id=fad9126e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports